import { Controller } from "@hotwired/stimulus"

// Automatically adds copy buttons to all code blocks within the controller scope
export default class extends Controller {
  connect() {
    this.addCopyButtons()
  }

  addCopyButtons() {
    const codeBlocks = this.element.querySelectorAll("pre")

    codeBlocks.forEach(pre => {
      // Skip if already has a copy button
      if (pre.querySelector(".code-copy-btn")) return

      // Create wrapper for positioning
      const wrapper = document.createElement("div")
      wrapper.className = "code-block-wrapper relative group"

      // Wrap the pre element
      pre.parentNode.insertBefore(wrapper, pre)
      wrapper.appendChild(pre)

      // Create copy button
      const button = document.createElement("button")
      button.type = "button"
      button.className = "code-copy-btn absolute top-2 right-2 p-2 rounded-lg bg-zinc-800 text-zinc-400 opacity-0 group-hover:opacity-100 hover:bg-zinc-700 hover:text-white transition-all duration-150"
      button.setAttribute("aria-label", "Copy code")
      button.innerHTML = `
        <svg class="copy-icon h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
        </svg>
        <svg class="check-icon h-4 w-4 hidden text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg>
      `

      button.addEventListener("click", () => this.copyCode(pre, button))
      wrapper.appendChild(button)
    })
  }

  async copyCode(pre, button) {
    const code = pre.querySelector("code")
    const text = code ? code.textContent : pre.textContent

    try {
      await navigator.clipboard.writeText(text)
      this.showSuccess(button)
    } catch (err) {
      console.error("Failed to copy code:", err)
    }
  }

  showSuccess(button) {
    const copyIcon = button.querySelector(".copy-icon")
    const checkIcon = button.querySelector(".check-icon")

    copyIcon.classList.add("hidden")
    checkIcon.classList.remove("hidden")

    setTimeout(() => {
      copyIcon.classList.remove("hidden")
      checkIcon.classList.add("hidden")
    }, 1500)
  }
}
